import { useEffect } from 'react';
import { React, useState } from 'react';
import { Form, Button, Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import * as api from 'services/api';
import { useTranslation } from 'react-i18next';
import { useConfig } from 'contexts/ConfigContext';

export function InterventionTypeForm({ interventionTypeFormData, handleSubmit, handleInputChange, error, setError, isEditing }) {
    const { t } = useTranslation();
    const { configData } = useConfig();
    const navigate = useNavigate();
    const [integrationActions, setIntegrationActions] = useState([]);


    const handleFormSubmit = (event) => {
        event.preventDefault();

        const fieldNames = {
            name: t('interventionTypeName')
        };

        for (const field of Object.keys(fieldNames)) {
            if (!isEditing) {
                if (!interventionTypeFormData[field]) {
                    setError(`${fieldNames[field]} ${t('usFieldRequired')}`);
                    return;
                }
            }
        }

        setError('');

        handleSubmit();
    };

    useEffect(() => {

        const fetchActions = async () => {
            const actions = await api.getIntegrationActions();
            if (actions.status === 200) {
                setIntegrationActions(actions.data);

            } else {
                console.error(t('errorObtainingActions'));
            }
        };

        fetchActions();

    }, []);

    const handleCancel = () => {
        setError('');
        navigate('/interventionTypeManagement');
    };


    return (
        <Form className="mt-5" onSubmit={handleFormSubmit}>
            <Stack direction="horizontal" gap={4} className="mt-3">
            <Form.Group controlId="name" className="col-3">
                    <Form.Label className="small">{t('it.Name')}</Form.Label>
                <Form.Control
                type="text"
                className="bg-light"
                name="name"
                            value={interventionTypeFormData.name}
                onChange={handleInputChange}
                />
            </Form.Group>

            <Form.Group controlId="text" className="col-5">
                    <Form.Label className="small">{t('it.Text')}</Form.Label>
                <Form.Control
                type="text"
                className="bg-light"
                name="text"
                            value={interventionTypeFormData.text}
                onChange={handleInputChange}
                />
                </Form.Group>

                <Form.Group controlId="enable" className="col-2">
                    <Form.Label className="small">{t('it.Status')}</Form.Label>
                    <Form.Select
                        name="enable"
                        className="bg-light"
                        value={interventionTypeFormData.enable}
                        onChange={(event) => {
                            const enable = event.target.value === 'true';
                            handleInputChange({
                                target: {
                                    name: 'enable',
                                    value: enable,
                                },
                            });
                        }}
                    >
                        <option value={'true'} >{t('it.Enable')}</option>
                        <option value={'false'}>{t('it.Disable')}</option>
                    </Form.Select>
                </Form.Group>

            

            </Stack>

            <Stack direction="horizontal" gap={4} className="mt-4">
                <>
                    <Form.Group controlId="mobileDevice" className="col-2">
                        <Form.Label className="small">{t('it.MobileDevice')}</Form.Label>
                        <Form.Select
                            name="mobileDevice"
                            className="bg-light"
                            value={interventionTypeFormData.mobileDevice}
                            onChange={(event) => {
                                const mobileDevice = event.target.value === 'true';
                                handleInputChange({
                                    target: {
                                        name: 'mobileDevice',
                                        value: mobileDevice,
                                    },
                                });
                            }}
                        >
                            <option value={'true'} >{t('it.Yes')}</option>
                            <option value={'false'}>{t('it.No')}</option>
                        </Form.Select>
                    </Form.Group>
                    {interventionTypeFormData.mobileDevice === true && (
                    <>
                        <Form.Group controlId="checkLocation" className="col-3">
                            <Form.Label className="small">{t('it.CheckLocation')}</Form.Label>
                            <Form.Select
                                    name="checkLocation"
                                    className="bg-light"
                                    value={interventionTypeFormData.checkLocation}
                                    onChange={(event) => {
                                        const checkLocation = event.target.value === 'true';
                                        handleInputChange({
                                            target: {
                                                name: 'checkLocation',
                                                value: checkLocation,
                                            },
                                        });
                                    }}
                            >
                                <option value={'true'} >{t('it.Yes')}</option>
                                <option value={'false'}>{t('it.No')}</option>
                            </Form.Select>
                        </Form.Group>
                    </>
                )}
                </>
            </Stack>

            <Stack direction="horizontal" gap={4} className="mt-4">

                <Form.Group controlId="enable" className="col-2">
                    <Form.Label className="small">{t('it.UpdatePhone')}</Form.Label>
                    <Form.Select
                        name="updatePhone"
                        className="bg-light"
                        value={interventionTypeFormData.updatePhone}
                        onChange={(event) => {
                            const updatePhone = event.target.value === 'true';
                            handleInputChange({
                                target: {
                                    name: 'updatePhone',
                                    value: updatePhone,
                                },
                            });
                        }}
                    >
                        <option value={'true'} >{t('it.Yes')}</option>
                        <option value={'false'}>{t('it.No')}</option>
                    </Form.Select>
                </Form.Group>
                {interventionTypeFormData.updatePhone === true && (
                    <>
                        <Form.Group controlId="selectedPhone" className="col-2">
                            <Form.Label className="small">{t('it.SelectedPhone')}</Form.Label>
                            <Form.Select
                                name="selectedPhone"
                                className="bg-light"
                                value={interventionTypeFormData.selectedPhone}
                                onChange={handleInputChange}
                            >
                                <option value={1}>{t('it.Phone1')}</option>
                                <option value={2}>{t('it.Phone2')}</option>
                                {interventionTypeFormData.mobileDevice === false && (< option value={3}>{t('it.Phone3')}</option>)}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group controlId="deletePhone" className="col-2">
                            <Form.Label className="small">{t('it.DeleteOrMove')}</Form.Label>
                            <Form.Select
                                name="deletePhone"
                                className="bg-light"
                                value={interventionTypeFormData.deletePhone}
                                onChange={(event) => {
                                    const deletePhone = event.target.value === 'true';
                                    handleInputChange({
                                        target: {
                                            name: 'deletePhone',
                                            value: deletePhone,
                                        },
                                    });
                                }}
                            >
                                <option value={'true'} >{t('it.DeletePhone')}</option>
                                <option value={'false'}>{t('it.MovePhone')}</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group controlId="controlDigitsNumber" className="col-2">
                            <Form.Label className="small">{t('it.DigitsNumber')}</Form.Label>
                            <Form.Control
                                type="number"
                                className="bg-light"
                                name="controlDigitsNumber"
                                value={interventionTypeFormData.controlDigitsNumber}

                                onChange={(e) => {
                                    const value = e.target.value;
                                    // Permitir solo n�meros entre 0 y 99
                                    if (/^\d{0,2}$/.test(value)) {
                                        handleInputChange(e);
                                    }
                                }}
                                min="0"
                                max="30"

                            />
                        </Form.Group>

                    </>
                )}
                                   
            </Stack>
            {configData.integration === true && (
                <Stack direction="horizontal" gap={4} className="mt-4">

                    <Form.Group controlId="integrationId" className="col-3">
                        <Form.Label className="small">{t('it.IntegrationId')}</Form.Label>

                        <Form.Select className="bg-light"
                            name='integrationId'
                            onChange={handleInputChange}
                            value={interventionTypeFormData.integrationId}
                        >
                            {integrationActions.map(action => (
                                <option key={action.value} value={action.value}>
                                    {action.value + ' (' + t(`${action.text}`) + ')'}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Stack>
            )}

            <Stack direction="horizontal" className="justify-content-start">
            {error && <p className="text-danger fw-semibold">{error}</p>}
            </Stack>

            <Stack direction="horizontal" gap={4} className="mt-3">
            <Button type="submit" variant="dark" className="mt-3">{t('usSave')}</Button>
            <Button variant="outline-dark" className="mt-3" onClick={handleCancel}>{t('usCancel')}</Button>
            </Stack>
        </Form>
    );
}
